
export default function() { return(Buffer.from('./calibri-regular.ttf', "base64").toString()) }
